import "../../css/pageLayout.css"
import { parseJsonField } from "../../utils/parseJsonField";

function GallerySection({ section }) {
  const settings = parseJsonField(section.settings_json);
  const items = section.items || [];
  const columns = settings.columns || 3;

  return (
    <section className="gallery-section">
      {settings.title && <h2>{settings.title}</h2>}

      <div
        className="gallery-grid"
        style={{
          gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`
        }}
      >
        {items
          .filter((item) => item.is_visible !== false)
          .map((item) => {
            const content = parseJsonField(item.content_json);

            return (
              <figure key={item.id} className="gallery-item">
                {content.image_url ? (
                  <img src={content.image_url} alt={content.caption || ""} />
                ) : (
                  <div>Image ID: {content.image_id}</div>
                )}

                {content.caption && <figcaption>{content.caption}</figcaption>}
              </figure>
            );
          })}
      </div>
    </section>
  );
}

export default GallerySection;